<div class="contact-card" [class.bordered]="isPlugin">
    <div class="description">
        <div class="name">
            <input
                #nameInput
                type="text"
                placeholder="Enter name"
                name="name"
                [(ngModel)]="contact.name"
                autocomplete="off"
            />
        </div>
        <div class="email">
            <input
                type="text"
                placeholder="Enter email"
                name="email"
                [(ngModel)]="contact.email"
                #email="ngModel"
                autocomplete="off"
                required
                email
            />
        </div>
    </div>
    <div *ngIf="email.invalid && email.touched" class="form__warning">Please enter valid email</div>
    <div class="ui icon buttons">
        <button *ngIf="isLoading" class="ui loading button">Loading</button>
        <ng-container *ngIf="!isLoading">
            <button class="ui mini button check" (click)="handleAdd(contact)">
                <i class="ui icon large check"></i>
            </button>
            <button class="ui mini button remove" (click)="handleClose()">
                <i class="ui icon large times"></i>
            </button>
        </ng-container>
    </div>
</div>
